import { Component, Input, HostBinding } from '@angular/core';

export type StatusBadgeTone = 'success' | 'info' | 'warning' | 'danger' | 'neutral';
export type StatusBadgeVariant = 'solid' | 'outline';
export type StatusBadgeSize = 'sm' | 'md';

@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss']
})
export class StatusBadgeComponent {
  @Input() label = '';
  @Input() tone: StatusBadgeTone = 'neutral';
  @Input() variant: StatusBadgeVariant = 'outline';
  @Input() size: StatusBadgeSize = 'md';
  @Input() dot = false;

  @HostBinding('class') get hostClass(): string {
    return [
      'ui-badge',
      `ui-badge--${this.tone}`,
      `ui-badge--${this.variant}`,
      `ui-badge--${this.size}`
    ].join(' ');
  }
}
